<template>
    <div class="service-data-wrapper">
        <ChannelSelect class="channel-select" value="all" @change="channelChange" />
        <LangSelect value="all" class="lang-select" :requireAll="true" @change="langChange"></LangSelect>
        <div class="data-detail-title">
            <span class="tit">{{ title }}</span>
            <span class="sel-time">{{ searchDate }}:</span>
            <el-date-picker v-model="dateValue" type="date" value-format="yyyy-MM-dd" :placeholder="selectDate" :picker-options="pickerOptions">
            </el-date-picker>
        </div>
        <Cumulative :lang="initLang" :channel="channelValue" :date="dateValue" :title="title" />
        <ServiceTiket :lang="initLang" :channel="channelValue" :date="dateValue" />

        <div class="more-data-tit">{{ moreData }}</div>
        <dataTrend :lang="initLang" :channel="channelValue" />
        <Detail :lang="initLang" :channel="channelValue" />
    </div>
</template>

<script>
import ChannelSelect from "@/views/zhiji/components/channelSelect/index";
import LangSelect from "@/components/langSelect";
import Cumulative from "./components/cumulative";
import ServiceTiket from "./components/tiket";
import dataTrend from "./components/dataTrend";
import Detail from "./components/detail";

export default {
    name: "serviceDataPage",
    components: {
        LangSelect,
        Cumulative,
        ServiceTiket,
        dataTrend,
        Detail,
        ChannelSelect
    },
    computed: {
        title() {
            return this.$t("zhiji.serviceData.cumulativeTitle");
        },
        searchDate() {
            return this.$t("zhiji.serviceData.searchDate");
        },
        moreData() {
            return this.$t("zhiji.serviceData.moreData");
        },
        selectDate() {
            return this.$t("zhiji.serviceData.selectDate");
        }
    },
    data() {
        return {
            channelValue: "",
            initLang: "",
            dateValue: this.zhiji.getDate(new Date(), 1, "YYYY-MM-DD"),
            pickerOptions: {
                disabledDate(time) {
                    const day = 24 * 3600 * 1000;
                    return time.getTime() + 1 * day > Date.now();
                }
            }
        };
    },
    methods: {
        langChange(data) {
            data == "all" ? (this.initLang = "") : (this.initLang = data);
        },
        channelChange(data) {
            data == "all" ? (this.channelValue = "") : (this.channelValue = data);
        }
    }
};
</script>

<style lang="scss" scoped>
.service-data-wrapper {
    padding: 20px 16px;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    background: #fafbfd;
}
.service-data-wrapper .tit,
.more-data-tit {
    font-weight: bold;
    margin: 0 20px 8px 0;
    font-size: 14px;
}
.sel-time {
    color: #797d8e;
    font-size: 14px;
}
.data-detail-title {
    margin: 8px 0 2px 0;
    /deep/.el-input .el-input__inner {
        font-size: 14px;
        color: #797d8e;
        background: transparent;
    }
    /deep/.el-date-editor {
        background: transparent;
    }
    /deep/.el-icon-date:before {
        position: relative;
        top: 2px;
    }
}
.channel-select {
    margin-right: 16px;
}
</style>
